import { Alignment } from "./constants/Alignment";

export class AlignmentUtil {
    public static getOppositeAlignment(alignment: Alignment): Alignment {
        switch (alignment) {
            case Alignment.TOP: return Alignment.BOTTOM;
            case Alignment.BOTTOM: return Alignment.TOP;
            case Alignment.RIGHT: return Alignment.LEFT;
            case Alignment.LEFT: return Alignment.RIGHT;
            default: return alignment;
        }
    }

    /** Used to manage alignment by flex direction
     * @param alignment The alignment that informs the flex direction
     * @param elementsReverseOrdered If the elements are reverse ordered, the flex direction will be reversed.
     *   </br>For example of LEFT alignment [<IMAGE> then <TEXT>]:
     *   </br> If an image element is placed before the span. That is "row" flex direction.
     *   </br> If an image element is placed after the span, but you still wanted to see [<IMAGE> then <TEXT>], that is "row-reverse" flex direction.
     */
    public static getFlexDirection(alignment: Alignment, elementsReverseOrdered: boolean = false): string {
        if (elementsReverseOrdered) {
            switch (alignment) {
                case Alignment.TOP: return "column-reverse";
                case Alignment.BOTTOM: return "column";
                case Alignment.RIGHT: return "row";
                case Alignment.LEFT: return "row-reverse";
                default: return "row-reverse";
            }
        }

        switch (alignment) {
            case Alignment.TOP: return "column";
            case Alignment.BOTTOM: return "column-reverse";
            case Alignment.RIGHT: return "row-reverse";
            case Alignment.LEFT: return "row";
            default: return "row";
        }
    }
}
